var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgN8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #005799;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.97,15.74c2.6,0,4.67.61,6.19,1.82s2.29,2.88,2.29,5.02c0,1.41-.44,2.69-1.31,3.85s-2.27,2.21-4.18,3.16c2.32,1.11,3.96,2.27,4.94,3.49s1.46,2.63,1.46,4.23c0,2.37-.83,4.26-2.48,5.67s-3.92,2.12-6.8,2.12c-3.05,0-5.39-.67-7.03-2s-2.46-3.23-2.46-5.67c0-3.27,1.99-5.81,5.98-7.64-1.8-1.02-3.09-2.11-3.87-3.29s-1.17-2.5-1.17-3.96c0-2.07.76-3.72,2.29-4.95s3.58-1.85,6.14-1.85Zm-6.17,21.76c0,1.56.54,2.78,1.63,3.65s2.61,1.31,4.58,1.31,3.45-.46,4.53-1.37,1.62-2.16,1.62-3.75c0-1.26-.51-2.39-1.52-3.37s-2.79-1.94-5.31-2.86c-1.94.83-3.35,1.75-4.22,2.76s-1.31,2.22-1.31,3.62Zm6.13-19.12c-1.63,0-2.9.39-3.83,1.17s-1.39,1.82-1.39,3.12c0,1.2.38,2.23,1.15,3.09s2.19,1.72,4.26,2.58c1.86-.78,3.18-1.62,3.96-2.52s1.16-1.95,1.16-3.14c0-1.32-.47-2.36-1.42-3.13s-2.24-1.16-3.9-1.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgN8);
export default __webpack_public_path__ + "static/media/n8.6756a508519257a842c0ff624655e205.svg";
export { ForwardRef as ReactComponent };